import { useEffect, useRef } from "react";
import store from "../store";
import backend from "../api";

export const copy = (x) => JSON.parse(JSON.stringify(x));
export const loading = (val) =>
  val
    ? (document.querySelector(".loader-wrapper").style.display = "block")
    : (document.querySelector(".loader-wrapper").style.display = "none");
export { default as Notification } from "./notification";
export const url_encode = (x) => encodeURI(JSON.stringify(x));
export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export const get_current_status = (state) => {
  let status_title = null;
  let status_message = null;
  let status_date = null;
  let status_ = null
  if(state?.status){    
    status_ = Object.keys(state.status).sort(
      (a, b) =>
        Date.parse(state.status[b].date) - Date.parse(state.status[a].date)
    )[0];
    status_message = state.status[status_].message;
    status_date = state.status[status_].date;
  }
  switch (status_) {
    case "checked_out":
      status_title = "Checked Out";
      break;
    case "declined":
      status_title = "Declined";
      break;
    case "in_progress":
      status_title = "in_progress";
      break;
    case "delivered":
      status_title = "Delivered";
      break;
    case "cancel":
      status_title = "Cancel Requested";
      break;
    case "return":
      status_title = "Return Requested";
      break;
    default:
      break;
  }
  return { status_title, status_message, status_date };
};

export const get_status = (state) => {
  let status_title = null;
  let status_message = null;
  let status_date = null;
  let status_ = Object.keys(state.status).sort(
    (a, b) =>
      Date.parse(state.status[b].date) - Date.parse(state.status[a].date)
  )[0];
  status_message = state.status[status_].message;
  status_date = state.status[status_].date;
  switch (status_) {
    case "checked_out":
      status_title = "checked_out";
      break;
    case "declined":
      status_title = "declined";
      break;
    case "in_progress":
      status_title = "in_progress";
      break;
    case "delivered":
      status_title = "delivered";
      break;
    case "cancel":
      status_title = "cancel";
      break;
    case "return":
      status_title = "return";
      break;
    default:
      break;
  }
  return { status_title, status_message, status_date };
};
export const get_for_customer = (user, component) => {
  if (!user) {
    return component;
  } else if (user?.user?.role === "customer") {
    return component;
  }
};
export const get_for_merchant = (user, component) => {
  if (!user) {
    return null;
  }
  if (user?.user?.role === "merchant") {
    return component;
  }
};
export const get_for_merchant_and_brand = (user, component) => {
  if (!user) {
    return null;
  }
  if (user?.user?.role === "merchant" || user.role === "brand") {
    return component;
  }
};
export const get_for_member = (user, component) => {
  if (user && user?.user?.role === "member") return component;
};

export const show_for = (role, component) => {
  const user = store.getState().auth?.user?.user;
  if (!user && role.includes("customer")) {
    return component;
  } else if (user && role.includes(user.role)) {
    return component;
  }
  return null;
};
export const get_promotion_prize = (product) =>
  (product?.member_prize_type === "percentage"
    ? (product?.product_price * product?.member_prize_value) / 100
    : product?.member_prize_value
  )?.toFixed(2);

export const upload_images = (images) =>
  backend.post("/file", images, {
    headers: {
      "content-type": `multipart/form-data`,
    },
  });

export const url_to_file = (urls) => {
  return urls
    .map((i) => Promise.all(fetch(i)))
    .then((res) => {
      return res.map(async (img) => {
        const blob = await img.blob();
        return new File([blob], "image.jpg", { type: blob.type });
      });
    });
};

export function copy_text_to_clipboard(text) {
  // const status = new Notification();
  var textArea = document.createElement("textarea");
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    // return (1)
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
    // return(0)
  }

  document.body.removeChild(textArea);
}
